import React from 'react'
import { useState } from 'react'
import "./ImageModal.css"

const ImageModal = ({ modalObj, closer }) => {

    const images = [modalObj?.front_url, modalObj?.back_url]
    const [currImage, setCurrImage] = useState(0)

    const next = () => {
        if (currImage >= images.length-1) 
            return

        setCurrImage(currImage+1)
    }

    const prev = () => {
        if (currImage === 0) 
            return

        setCurrImage(currImage-1)
    }

    return (
        <div id="docModal" className="doc-modal">
            {/* <!-- The Close Button --> */}
            <span className="close" onClick={closer}>&times;</span>
            {currImage !== 0 && <button className="prevBtn cursor-pointer" onClick={prev}>&lt;</button>}
            {currImage !== images.length-1 && <button className="nextBtn cursor-pointer" onClick={next}>&gt;</button>}

            {/* <!-- doc-Modal Content (The Image) --> */}
            <img className="doc-modal-content" id="img01" src={images[currImage]} alt='' />

            {/* <!-- doc-Modal Caption (Image Text) --> */}
            <div id="caption">
                {modalObj.exp && <p>Expires: {modalObj.exp}</p>}
                {modalObj.idNumber && <p>ID Number: {modalObj.idNumber}</p>}
            </div>
        </div>
    )
}

export default ImageModal